import * as immutable from 'object-path-immutable';
import * as types from './actionTypes';

const initialState = {
  panelOpened: false,
  list: [],
  goodId: -1,
  freeCount: 0,
  freeAddedCount: 0,
};

export default function freeSaucesReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_PANEL:
      return {
        ...state,
        panelOpened: true,
        list: action.payload.sauces,
        goodId: action.payload.goodId,
        freeCount: action.payload.freeCount,
      };

    case types.HIDE_PANEL:
      return {
        ...state,
        panelOpened: false,
      };

    case types.CLEAN_FREE_SAUCES:
      return {
        ...state,
        ...initialState,
      };

    case types.ADD_TO_CART_REQUEST: {
      const indexOfItemToUpdate = state.list.findIndex(sauce => sauce.id === action.payload.id);
      return immutable.assign(state, ['list', indexOfItemToUpdate], {
        isAdding: true,
        isAdded: false,
        error: '',
      });
    }

    case types.ADD_TO_CART_SUCCESS: {
      const indexOfItemToUpdate = state.list.findIndex(sauce => sauce.id === action.payload.id);
      return immutable.assign(state, ['list', indexOfItemToUpdate], {
        isAdding: false,
        isAdded: true,
        freeAddedCount: state.freeAddedCount++,
      });
    }

    case types.ADD_TO_CART_FAILURE: {
      const indexOfItemToUpdate = state.list.findIndex(sauce => sauce.id === action.payload.id);
      return immutable.assign(state, ['list', indexOfItemToUpdate], {
        isAdding: false,
        isAdded: false,
        error: action.payload.error,
      });
    }

    default:
      return state;
  }
}
